export const color = {
  textWhite: '#FFF',
  textGray: '#D1D3D4',
  bgButton:
    'var(--border, linear-gradient(90deg, #E86E00 -1.64%, #F18900 3.29%, #F99F00 9.22%, #FDAC00 14.15%, #FFB100 19.09%, #E86E00 97.07%))',
}
